import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { SubscriptionsSuccessResponse } from "./api-response/SubscriptionsSuccessResponse";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { map } from "rxjs/operators";

export class ApiSubscription {
  constructor(private apiEndpoint: string) {}

  listByUserAndOrganization(
    token: string,
    organization: string,
    userId: number
  ): Observable<SubscriptionsSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/users/${userId}/subscriptions`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  cancelByIdAndOrganization(
    token: string,
    organization: string,
    subscriptionId: string,
    immediately: boolean
  ): Observable<any> {
    return ajax({
      method: "POST",
      url: `${this.apiEndpoint}/organizations/${organization}/subscriptions/${subscriptionId}/cancel`,
      headers: getAuthAndDefaultHeaders(token),
      body: {
        immediately,
      },
    }).pipe(map((x: any) => x.response));
  }
}
